// extracted by mini-css-extract-plugin
module.exports = {"xs":"0","sm":"640","md":"1024","lg":"1440","xl":"1650","headerHeight":"80"};